export const m = {
  'ConnectBankAccountToLicensesForm.accountNumber': 'Account Number',

  'ConnectBankAccountToLicensesForm.openingDate': 'Opening Date',

  'ConnectBankAccountToLicensesForm.assignedLicenses': 'Assigned Licenses',
  'ConnectBankAccountToLicensesForm.assignedLicensesPlaceholder': 'Select the license',
  'ConnectBankAccountToLicensesForm.assignedLicenses.errorMsg': 'Field is required'
}
